import React, { useEffect, useState } from "react"
import { motion } from 'framer-motion'
import API from "../Common/API"
import { useHistory } from "react-router-dom"
import DoughnutChart from "../Components/DoughnutChart"
import { FaMoneyBillTrendUp } from "react-icons/fa6";
import { RiPassPendingFill } from "react-icons/ri";
import { FaUserCheck } from "react-icons/fa";
import { GrUpdate } from "react-icons/gr";
import { ImUserMinus } from "react-icons/im";
import { FaUserMinus } from "react-icons/fa";
import { PiTreeViewDuotone, PiTreeViewFill, PiTreeViewLight } from "react-icons/pi";
import * as Yup from 'yup'
import { useFormik } from "formik"
import FieldInput from "../Components/FieldInput"
import Button from "../Components/Button"

const initialMpin = {
    mobileNumber : ''
}

const Dashboard = () => {

    const [loading, setLoading] = useState(true)
    const [dashDetails, setDashDetails] = useState()
    const history = useHistory()
    const [pin, setPin] = useState('')

    const mpinFormSchema = Yup.object().shape({
        mobileNumber: Yup.string().required('Mobile number is required').matches(/^[0-9]{10}$/, 'Mobile number must be 10 digits'),
    })

    useEffect(() => {
        setLoading(true)
        API.get('/common/getAllDashboardDetails').then((dashRes) => {
            if (dashRes.status === 200) {
                setDashDetails(dashRes.data.data)
                setLoading(false)
            }
        })
    }, [])

    const mPinForm = useFormik({
        initialValues : initialMpin,
        validateOnMount : true,
        validationSchema : mpinFormSchema,
        onSubmit:(values)=>{
            API.get(`/auth/getMpin?mobileNumber=${values.mobileNumber}`).then((res)=>{
                if(res.status === 200){
                    setPin(res.data.data)
                }else{
                    setPin('No Mpin found for this number')
                }
            }).catch((err)=>{
                setPin('No Mpin found for this number')
            })
        }
    })

    return (
        <motion.div>
            {loading ? (
                "Loading please wait"
            ) : (
                <motion.div className="w-full h-full relative flex px-2 flex-col">
                    <motion.div className="flex flex-col justify-start md:flex-row gap-10">
                        <DoughnutChart data={dashDetails} />
                        <motion.div className="grid grid-cols-1 w-full sm:grid-cols-1 md:grid-cols-2 gap-5">
                            <motion.div className="grid grid-cols-1 w-full gap-5">
                                <motion.div className="h-32 cursor-pointer hover:scale-105 hover:transform-gpu gap-5 w-full justify-between bg-white shadow-md rounded-lg flex flex-col px-5 py-5" onClick={() => history.push(`/user/0`)}>
                                    <p className="text-lg font-bold">Pending User</p>
                                    <motion.div className="flex flex-row items-center justify-between">
                                        <p className="text-md font-bold">{dashDetails.pendingUser}</p>
                                        <motion.div className="h-14 w-14 bg-white drop-shadow-md rounded-md flex justify-center items-center">
                                            <RiPassPendingFill size={24} className="text-primeColor" />
                                        </motion.div>
                                    </motion.div>
                                </motion.div>
                                <motion.div className="h-32 cursor-pointer hover:scale-105 hover:transform-gpu gap-5 w-full bg-white justify-between shadow-md rounded-lg flex flex-col px-5 py-5" onClick={() => history.push(`/user/7`)}>
                                    <p className="text-lg font-bold">Paid Members</p>
                                    <motion.div className="flex flex-row items-center justify-between">
                                        <p className="text-md font-bold">{dashDetails.paidMembers}</p>
                                        <motion.div className="h-14 w-14 bg-white drop-shadow-md rounded-md flex justify-center items-center">
                                            <FaMoneyBillTrendUp size={24} />
                                        </motion.div>
                                    </motion.div>
                                </motion.div>
                            </motion.div>

                            <motion.div className="grid grid-cols-1 w-full gap-5">
                                <motion.div className="h-32 cursor-pointer hover:scale-105 hover:transform-gpu gap-5 w-full bg-white shadow-md rounded-lg flex flex-col px-5 py-5" onClick={() => history.push(`/user/1`)}>
                                    <p className="text-lg font-bold">Approved User</p>
                                    <motion.div className="flex flex-row items-center justify-between">
                                        <p className="text-md font-bold">{dashDetails.approvedUser}</p>
                                        <motion.div className="h-14 w-14 bg-white drop-shadow-md rounded-md flex justify-center items-center">
                                            <FaUserCheck size={24} className="text-[green]" />
                                        </motion.div>
                                    </motion.div>
                                </motion.div>
                                <motion.div className="h-32 cursor-pointer hover:scale-105 hover:transform-gpu gap-5 w-full bg-white shadow-md rounded-lg flex flex-col px-5 py-5" onClick={() => history.push(`/user/4`)}>
                                    <p className="text-lg font-bold">Happy Customer</p>
                                    <motion.div className="flex flex-row items-center justify-between">
                                        <p className="text-md font-bold">{dashDetails.happyCustomer}</p>
                                        <motion.div className="h-14 w-14 bg-white drop-shadow-md rounded-md flex justify-center items-center">
                                            <ImUserMinus size={24} className="text-[red]" />
                                        </motion.div>
                                    </motion.div>
                                </motion.div>
                            </motion.div>
                        </motion.div>
                        <motion.div className="rounded-lg shadow-md bg-white py-5 w-92">
                            <FieldInput type="phone" label={'Mobile Number'} placeholder={"Enter Mobile Number"} fieldHelper={mPinForm.getFieldHelpers('mobileNumber')} fieldMeta={mPinForm.getFieldMeta('mobileNumber')} fieldProps={mPinForm.getFieldProps('mobileNumber')} edit={true} dataLoaded={true} />
                            <Button type={'primary'} onClick={()=>mPinForm.handleSubmit()}>Check Mpin</Button>
                            <Button type={'secondary'} onClick={()=>{mPinForm.resetForm();setPin('')}}>Clear</Button>
                            {pin && <p className="text-center mt-5 text-lg font-bold">Mpin : {pin}</p>}
                         </motion.div>
                    </motion.div>
                    <motion.div className="grid grid-cols-1 w-full sm:grid-cols-1 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 gap-5 mt-5">
                        <motion.div className="h-32 cursor-pointer gap-5 w-full justify-between bg-white shadow-md rounded-lg flex flex-col px-5 py-5" onClick={() => history.push(`/user/6`)}>
                            <p className="text-lg font-bold">Updated Users</p>
                            <motion.div className="flex flex-row items-center justify-between">
                                <p className="text-md font-bold">{dashDetails.updatedUser || 0}</p>
                                <motion.div className="h-14 w-14 bg-white drop-shadow-md rounded-md flex justify-center items-center">
                                    <GrUpdate size={24} className="text-primeColor" />
                                </motion.div>
                            </motion.div>
                        </motion.div>
                        <motion.div className="h-32 cursor-pointer gap-5 w-full justify-between bg-white shadow-md rounded-lg flex flex-col px-5 py-5" onClick={() => history.push(`/user/2`)}>
                            <p className="text-lg font-bold">Deactivated Users</p>
                            <motion.div className="flex flex-row items-center justify-between">
                                <p className="text-md font-bold">{dashDetails.declinedUser || 0}</p>
                                <motion.div className="h-14 w-14 bg-white drop-shadow-md rounded-md flex justify-center items-center">
                                    <FaUserMinus size={24} className="text-[red]" />
                                </motion.div>
                            </motion.div>
                        </motion.div>
                        <motion.div className="h-32 cursor-pointer gap-5 w-full justify-between bg-white shadow-md rounded-lg flex flex-col px-5 py-5">
                            <p className="text-lg font-bold">Total Plans</p>
                            <motion.div className="flex flex-row items-center justify-between">
                                <p className="text-md font-bold">{dashDetails.totalPlans}</p>
                                <motion.div className="h-14 w-14 bg-white drop-shadow-md rounded-md flex justify-center items-center">
                                    <PiTreeViewDuotone size={24} className="text-primeColor" />
                                </motion.div>
                            </motion.div>
                        </motion.div>
                        <motion.div className="h-32 cursor-pointer gap-5 w-full justify-between bg-white shadow-md rounded-lg flex flex-col px-5 py-5">
                            <p className="text-lg font-bold">Active Plans</p>
                            <motion.div className="flex flex-row items-center justify-between">
                                <p className="text-md font-bold">{dashDetails.activePlans}</p>
                                <motion.div className="h-14 w-14 bg-white drop-shadow-md rounded-md flex justify-center items-center">
                                    <PiTreeViewFill size={24} className="text-primeColor" />
                                </motion.div>
                            </motion.div>
                        </motion.div>
                        <motion.div className="h-32 cursor-pointer gap-5 w-full justify-between bg-white shadow-md rounded-lg flex flex-col px-5 py-5">
                            <p className="text-lg font-bold">Deactivated Plans</p>
                            <motion.div className="flex flex-row items-center justify-between">
                                <p className="text-md font-bold">{dashDetails.deactivatedPlans}</p>
                                <motion.div className="h-14 w-14 bg-white drop-shadow-md rounded-md flex justify-center items-center">
                                    <PiTreeViewLight size={24} className="text-primeColor" />
                                </motion.div>
                            </motion.div>
                        </motion.div>
                    </motion.div>
                </motion.div>
            )
            }
        </motion.div>
    )
}

export default Dashboard